import * as React from 'react';
import * as ReactDOM from 'react-dom';
import '../styles/app.scss';
import LoginApp from './LoginApp';

function renderApp() {
	ReactDOM.render(<LoginApp />, document.getElementById('app'));
}

renderApp();

if ((module as any).hot) {
	(module as any).hot.accept('./LoginApp', () => {
		renderApp();
	});
}
